import { LOCATION_CHANGE } from 'react-router-redux'
import {
  getPartnershipAndConventionFromUrl,
  getFlowRawValue
} from '../../utils'

const initialState = {
  locationBeforeTransitions: null
}

export default (state = initialState, action) => {
  if (action.type === LOCATION_CHANGE) {
    const pAndC = getPartnershipAndConventionFromUrl(action.payload)

    if (pAndC.partnership === 'HYPE4TIM') {
      /* TODO: */
      document.title = 'Attivazione Carta TIMpersonal'
    } else {
      document.title = 'Richiesta POS'
    }

    return {
      ...state,
      locationBeforeTransitions: action.payload,
      flow: getFlowRawValue(pAndC.partnership, pAndC.convention),
      ...pAndC,
      container: action.payload.pathname.replace(/\/([^\/]+)\/.*/, '$1'),
      argument: action.payload.pathname.replace(
        /\/[^\/]+\/[^\/]+\/([^\/]+).*/,
        '$1'
      )
    }
  }

  return state
}



// WEBPACK FOOTER //
// ./state/reducers/routingReducer.js